(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.fab-SelectToggle{cursor:pointer;min-width:96px;position:relative;text-align:left;border:none;font-weight:400}.fab-SelectToggle--sizeBiggie,.fab-SelectToggle--sizeLarge{font-size:16px;height:36px}.fab-SelectToggle--sizeMedium{font-size:15px;height:34px}.fab-SelectToggle--sizeSmall{font-size:14px;height:32px}.fab-SelectToggle--sizeTeenie{font-size:13px;height:32px}.fab-SelectToggle--width1{width:48px}.fab-SelectToggle--width2{width:64px}.fab-SelectToggle--width3{width:96px}.fab-SelectToggle--width4{width:128px}.fab-SelectToggle--width5{width:160px}.fab-SelectToggle--width6{width:192px}.fab-SelectToggle--width7{width:224px}.fab-SelectToggle--width8{width:288px}.fab-SelectToggle--width9{width:352px}.fab-SelectToggle--width10{width:448px}.fab-SelectToggle--width100{width:100%}.fab-SelectToggle--sizeTeenie,.fab-SelectToggle--sizeSmall{height:32px}.fab-SelectToggle--sizeTeenie .fab-SelectToggle__content,.fab-SelectToggle--sizeTeenie .fab-SelectToggle__placeholder,.fab-SelectToggle--sizeSmall .fab-SelectToggle__content,.fab-SelectToggle--sizeSmall .fab-SelectToggle__placeholder{font-size:14px;line-height:20px}.fab-SelectToggle--sizeMedium{height:40px}.fab-SelectToggle--sizeMedium .fab-SelectToggle__content,.fab-SelectToggle--sizeMedium .fab-SelectToggle__placeholder{font-size:15px;line-height:22px}.fab-SelectToggle--sizeLarge,.fab-SelectToggle--sizeBiggie{height:48px}.fab-SelectToggle--sizeLarge .fab-SelectToggle__content,.fab-SelectToggle--sizeLarge .fab-SelectToggle__placeholder,.fab-SelectToggle--sizeBiggie .fab-SelectToggle__content,.fab-SelectToggle--sizeBiggie .fab-SelectToggle__placeholder{font-size:16px;line-height:24px}.fab-SelectToggle--clearable .fab-SelectToggle__clearButton{display:flex;fill:#777270;margin-right:6px}.fab-SelectToggle--focused .fab-SelectToggle__toggleButton{fill:#48413f;border-left-color:var(--fabric-theme-light, #87C276)}.fab-SelectToggle--focused .fab-SelectToggle__toggleButton--errorCondition{border-color:#de1429}.fab-SelectToggle--focused .fab-SelectToggle__toggleButton--infoCondition{border-color:#007db4}.fab-SelectToggle--focused .fab-SelectToggle__toggleButton--warningCondition{border-color:#cd4a00}.fab-SelectToggle--focused .fab-SelectToggle__innerFacade{border:1px solid var(--fabric-theme-light, #87C276);box-shadow:2px 2px 0 2px color-mix(in srgb,var(--fabric-theme-light, #87C276) 5%,transparent),0 0 0 .5px var(--fabric-theme-light, #87C276)}.fab-SelectToggle--focused .fab-SelectToggle__innerFacade--errorCondition{border-color:#de1429;box-shadow:2px 2px 0 2px #de14290d,0 0 0 .5px #de1429}.fab-SelectToggle--focused .fab-SelectToggle__innerFacade--infoCondition{border-color:#007db4;box-shadow:2px 2px 0 2px #007db40d,0 0 0 .5px #007db4}.fab-SelectToggle--focused .fab-SelectToggle__innerFacade--warningCondition{border-color:#cd4a00;box-shadow:2px 2px 0 2px #cd4a000d,0 0 0 .5px #cd4a00}.fab-SelectToggle--disabled{cursor:default}.fab-SelectToggle--disabled .fab-SelectToggle__guts{background-color:#f6f6f4}.fab-SelectToggle--disabled .fab-SelectToggle__innerFacade{border:1px solid #c6c2bf;box-shadow:none}.fab-SelectToggle--disabled .fab-SelectToggle__placeholder{color:#48413f}.fab-SelectToggle--disabled .fab-SelectToggle__toggleButton{border-color:#c6c2bf;fill:#868180}.fab-SelectToggle--disabled .fab-SelectToggle__clearButton{cursor:default;fill:#777270}.fab-SelectToggle--disabled .fab-SelectToggle__clearButton:hover{fill:#38312f}.fab-SelectToggle--view:hover .fab-SelectToggle__innerFacade{border:1px solid #d4d2d0;box-shadow:none}.fab-SelectToggle--view:hover .fab-SelectToggle__toggleButton{border-color:#d4d2d0;fill:#777270}.fab-SelectToggle--view .fab-SelectToggle__innerFacade{border:1px solid #e4e3e0;box-shadow:none}.fab-SelectToggle--view .fab-SelectToggle__toggleButton{border-color:#e4e3e0;fill:#777270}.fab-SelectToggle__clearButton{align-items:center;cursor:pointer;fill:#777270}.fab-SelectToggle__clearButton:hover{fill:#38312f}.fab-SelectToggle__container{position:relative;display:inline-block;width:100%}.fab-SelectToggle__clearButtonContainer{position:absolute;top:50%;right:42px;transform:translateY(-50%);height:100%;display:flex;align-items:center}.fab-SelectToggle__clearButtonPlaceholder{width:26px}.fab-SelectToggle__content,.fab-SelectToggle__placeholder{display:block;flex-grow:1;margin-right:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.fab-SelectToggle__guts{align-items:center;background-color:#fff;border-radius:8px;box-sizing:border-box;color:#48413f;display:flex;flex-basis:100%;font-size:inherit;height:100%;padding:8px 8px 8px 12px;-webkit-user-select:none;user-select:none}.fab-SelectToggle__guts--single{border-radius:1000px;padding:8px 8px 8px 16px}.fab-SelectToggle__innerFacade{border:1px solid #c6c2bf;box-shadow:1px 1px 0 1px #38312f0a;border-radius:8px;bottom:2px;left:2px;pointer-events:none;position:absolute;right:2px;top:2px;transition:box-shadow .3s cubic-bezier(.4,0,.2,1) 0ms}.fab-SelectToggle__innerFacade--errorCondition{border-color:#de1429}.fab-SelectToggle__innerFacade--infoCondition{border-color:#007db4}.fab-SelectToggle__innerFacade--warningCondition{border-color:#cd4a00}.fab-SelectToggle__innerFacade--single{border-radius:1000px}.fab-SelectToggle__outerFacade{border-radius:2px;bottom:-2px;pointer-events:none;position:absolute;left:-2px;right:-2px;top:-2px}.fab-SelectToggle__toggleButton{align-items:center;border-left:1px solid #c6c2bf;display:inline-flex;fill:#868180;flex-shrink:0;height:100%;justify-content:center;padding-left:6px;transition:border-color .3s cubic-bezier(.4,0,.2,1) 0ms;width:19px}.fab-SelectToggle__toggleButton--errorCondition{border-color:#de1429}.fab-SelectToggle__toggleButton--infoCondition{border-color:#007db4}.fab-SelectToggle__toggleButton--warningCondition{border-color:#cd4a00}.fab-SelectTextToggle{border-radius:8px;color:#0b4fd1;cursor:pointer;display:flex;font-size:15px;line-height:22px;position:relative;text-align:left}.fab-SelectTextToggle--sizeTeenie,.fab-SelectTextToggle--sizeSmall{font-size:14px;line-height:20px}.fab-SelectTextToggle--sizeMedium{font-size:15px;line-height:22px}.fab-SelectTextToggle--sizeLarge,.fab-SelectTextToggle--sizeBiggie{font-size:16px;line-height:24px}.fab-SelectTextToggle:hover{color:var(--fabric-theme-base, #2E7918);text-decoration:underline}.fab-SelectTextToggle:hover .fab-SelectTextToggle__toggleButton{fill:var(--fabric-theme-base, #2E7918)}.fab-SelectTextToggle--focused{text-decoration:none}.fab-SelectTextToggle--focused:after{border-radius:8px;border:2px solid color-mix(in srgb,var(--fabric-theme-base, #2E7918) 80%,transparent);bottom:-8px;content:"";left:0;position:absolute;right:0;top:-8px}.fab-SelectTextToggle--opened{color:var(--fabric-theme-base, #2E7918);text-decoration:none}.fab-SelectTextToggle--opened .fab-SelectTextToggle__toggleButton{fill:var(--fabric-theme-base, #2E7918)}.fab-SelectTextToggle--dark,.fab-SelectTextToggle--dark:hover{color:#fff}.fab-SelectTextToggle--dark:hover .fab-SelectTextToggle__toggleButton,.fab-SelectTextToggle--dark .fab-SelectTextToggle__toggleButton{fill:#fff}.fab-SelectTextToggle__clearButton{display:none}.fab-SelectTextToggle__guts{align-items:center;display:flex;flex-basis:auto;font-weight:600;min-width:1px;padding:0 10px;-webkit-user-select:none;user-select:none}.fab-SelectTextToggle__toggleButton{display:inline-flex;fill:#0b4fd1;flex-shrink:0;margin-left:8px}.fab-Select{align-items:flex-start;display:inline-flex;flex-direction:column}.fab-Select--fullWidth{width:100%}[data-fabric-mode=dye] .fab-Select{outline:2px solid #ff6a00}')),document.head.appendChild(e)}}catch(l){console.error("vite-plugin-css-injected-by-js",l)}})();
var Z = Object.defineProperty;
var B = (s, e, t) => e in s ? Z(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var V = (s, e, t) => B(s, typeof e != "symbol" ? e + "" : e, t);
import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { c as D } from "./index-DkZ16bcJ.mjs";
import { l as d } from "./lodash-5ofSKtz3.mjs";
import { PureComponent as J, createRef as Q, Component as K } from "react";
import { f as C } from "./index-LyFokDcn.mjs";
import { g as Y } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { r as ee } from "./index-DH8DM7A9.mjs";
import { I as te } from "./icon-v2-DGtVEk7e.mjs";
import { d as se } from "./index-DspsydPg.mjs";
import { s as ne } from "./sizes-DktS74Qp.mjs";
import { w as T, h as oe, b as N, o as ie, m as ae, M as re, j as le } from "./menu-63UgiRJf.mjs";
import { a as ce, I as de } from "./X10x10-Bso1Otyr.mjs";
import { I as ue } from "./icon-button-BxDvkq_l.mjs";
import { _ as pe } from "./composeRefs-YONvD-rx.mjs";
class he extends J {
  constructor() {
    super(...arguments);
    V(this, "_handleValidation", (t = {}) => {
      const { onValidation: n } = this.props, {
        detail: { isValid: o }
      } = t;
      n(o);
    });
    V(this, "_ref", Q());
  }
  _triggerInputEvent(t) {
    t.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0
      })
    ), t.dispatchEvent(
      new CustomEvent("input", {
        bubbles: !0
      })
    );
  }
  componentDidMount() {
    const { current: t } = this._ref;
    t && t.addEventListener("validation", this._handleValidation);
  }
  componentDidUpdate(t) {
    const { selectedValues: n } = t, { selectedValues: o } = this.props;
    d.isEqual(n, o) || this._triggerInputEvent(this._ref.current);
  }
  componentWillUnmount() {
    const { current: t } = this._ref;
    t && t.removeEventListener("validation", this._handleValidation);
  }
  render() {
    const { canSelectMultiple: t, id: n, inputRef: o, isDisabled: u, name: r, onFocus: c, required: _, selectedValues: l = [] } = this.props, f = {};
    let i = t ? l : l.slice(-1);
    i.length === 0 && (i = [""], f["data-has-default-value"] = "");
    const b = t ? i : i[0], p = pe(this._ref, o);
    return /* @__PURE__ */ a.jsx(
      "select",
      {
        ...f,
        "aria-hidden": !0,
        className: "chzn-ignore",
        disabled: u,
        id: n,
        multiple: t,
        name: r,
        onFocus: c,
        readOnly: !0,
        ref: p,
        required: _,
        style: { border: "none", height: 0, opacity: 0, overflow: "hidden", position: "absolute", width: 0 },
        tabIndex: -1,
        value: b,
        children: i.map((m) => /* @__PURE__ */ a.jsx("option", { value: m }, m))
      }
    );
  }
}
var fe = ee();
const me = /* @__PURE__ */ Y(fe), z = window.jQuery ? $.__("–Select–") : "–Select–", U = "medium", ge = "3", M = se.createLogger("@fabric/select/util | <Select />");
function _e(s, e = {}) {
  const {
    appliedPlacement: t = {},
    condition: n,
    isClearable: o,
    isDark: u,
    isDisabled: r,
    isFocused: c,
    isInvalid: _,
    isOpen: l,
    selectedItems: f,
    size: i,
    type: b,
    width: p
  } = e, { widths: m, heights: w } = ne;
  let g = i, S = p;
  if (!d.isUndefined(p) && !m.hasOwnProperty(p)) {
    const h = Object.keys(m).map((x) => `"${x}"`);
    S = ge, M.error(`An invalid width was supplied. Expected one of ${h}. Got "${p}".`);
  }
  if (!w.hasOwnProperty(i)) {
    const h = Object.keys(w).map((x) => `"${x}"`);
    g = U, M.error(`An invalid size was supplied. Expected one of ${h}. Got "${i}".`);
  }
  return D(
    {
      [s]: !0,
      [`${s}--bottom`]: l && t.side === "bottom",
      [`${s}--dark`]: u,
      [`${s}--disabled`]: r,
      [`${s}--clearable`]: o && b !== "text" && f.length > 0,
      [`${s}--focused`]: !r && c,
      [`${s}--opened`]: !r && l,
      [`${s}--top`]: t.side === "top" && l,
      [`${s}--view`]: b === "view" && !r && !_ && !l && C.ifFeature("encore", !n, !0),
      [`${s}--width${S}`]: p
    },
    `${s}--size${d.startCase(g)}`
  );
}
function ve(s = "", { condition: e = "" } = {}, { variant: t = "" } = {}) {
  return C.ifFeature(
    "encore",
    D(
      `${s}__innerFacade`,
      {
        [`${s}__innerFacade${T(e)}`]: !!e
      },
      {
        [`${s}__innerFacade--${t}`]: !!t
      }
    ),
    D(`${s}__innerFacade`, {
      [`${s}__innerFacade${T(e)}`]: !!e
    })
  );
}
function be(s = "", { variant: e = "" } = {}) {
  const t = `${s}__guts`;
  return C.ifFeature(
    "encore",
    D(t, {
      [`${t}--${e}`]: !!e
    }),
    D(t)
  );
}
function Se(s = "", { condition: e = "" } = {}) {
  return D(`${s}__toggleButton`, {
    [`${s}__toggleButton${T(e)}`]: !!e
  });
}
function q(s, e, t) {
  if (d.isFunction(e))
    return e(s);
  if (!t || s.length === 1)
    return d.last(s).text;
  if (s.length > 1)
    return window.jQuery ? $.__n("%s Selected", "%s Selected", s.length) : `${s.length} Selected`;
}
function xe(s) {
  const {
    appliedPlacement: e = {},
    ariaDescribedby: t,
    biId: n,
    buttonProps: o,
    canSelectMultiple: u,
    condition: r,
    isClearable: c,
    isDark: _,
    isDisabled: l,
    isFocused: f,
    isInvalid: i,
    isOpen: b,
    onClear: p,
    placeholder: m,
    renderToggleContent: w,
    selectedItems: g = [],
    size: S,
    type: h,
    variant: x,
    width: E
  } = s, y = h === "text" ? "fab-SelectTextToggle" : "fab-SelectToggle", v = new me(y), O = _e(y, {
    appliedPlacement: e,
    condition: C.ifFeature("encore", r),
    isClearable: c,
    isDark: _,
    isDisabled: l,
    isFocused: f,
    isInvalid: i,
    isOpen: b,
    selectedItems: g,
    size: S,
    type: h,
    width: E
  }), F = {};
  n && (F["data-bi-id"] = `${n}-select-toggle`);
  const P = () => h === "text" && (S === "small" || S == "teenie") ? 10 : 16;
  return /* @__PURE__ */ a.jsxs("div", { className: v.elem("container"), children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: O,
        ...F,
        ...o,
        "aria-invalid": i ? !0 : void 0,
        "aria-describedby": t,
        role: "button",
        children: [
          /* @__PURE__ */ a.jsx("div", { className: v.elem("outerFacade"), children: /* @__PURE__ */ a.jsx("div", { className: ve(y, { condition: r }, { variant: x }) }, "innerFacade") }, "outerFacade"),
          /* @__PURE__ */ a.jsxs("div", { className: be(y, { variant: x }), children: [
            g.length ? /* @__PURE__ */ a.jsx("div", { className: v.elem("content"), children: q(g, w, u) }) : null,
            m && g.length < 1 ? /* @__PURE__ */ a.jsx("div", { className: v.elem("placeholder"), children: m }) : null,
            c && h !== "text" && h !== "view" && g.length > 0 && /* @__PURE__ */ a.jsx("div", { className: v.elem("clearButtonPlaceholder") }),
            /* @__PURE__ */ a.jsx("div", { className: C.ifFeature("encore", Se(y, { condition: r }), v.elem("toggleButton")), children: C.ifFeature("encore", /* @__PURE__ */ a.jsx(te, { name: "caret-down-solid", size: P() }), /* @__PURE__ */ a.jsx(ce, { "aria-hidden": !0 })) })
          ] })
        ]
      }
    ),
    c && h !== "text" && h !== "view" && g.length > 0 && /* @__PURE__ */ a.jsx("div", { className: v.elem("clearButtonContainer"), children: C.ifFeature(
      "encore",
      /* @__PURE__ */ a.jsx(
        ue,
        {
          "aria-label": window.jQuery ? $.__("Clear Selection") : "Clear Selection",
          className: v.elem("clearButton"),
          icon: "xmark-regular",
          size: 16,
          noBoundingBox: !0,
          onClick: (j) => {
            p();
          },
          type: "button"
        }
      ),
      /* @__PURE__ */ a.jsx(
        "div",
        {
          className: v.elem("clearButton"),
          onClick: (j) => {
            j.preventDefault(), j.stopPropagation(), p();
          },
          children: /* @__PURE__ */ a.jsx(de, { "aria-hidden": !0 })
        }
      )
    ) })
  ] });
}
const A = class A extends K {
  constructor() {
    super(...arguments), this._handleClear = () => {
      const { isDisabled: e, onClear: t = d.noop } = this.props;
      if (e)
        return;
      const n = t();
      return Promise.resolve(n).then(() => this._change([]));
    }, this._handleDeselect = (e, t) => this._deselect(e, t), this._handleSelect = (e, t, n) => this._select(e, t, n), this._handleValidation = (e) => {
      this.setState({ isInvalid: !e });
    }, this._renderToggle = ({ appliedPlacement: e, isFocused: t }, n) => {
      const {
        ariaDescribedby: o,
        biId: u,
        canSelectMultiple: r,
        isClearable: c,
        isDark: _,
        isDisabled: l,
        open: f,
        placeholder: i,
        renderToggleContent: b,
        size: p,
        type: m,
        variant: w,
        width: g
      } = this.props, { isOpen: S, selectedItems: h } = this.state, x = typeof f == "boolean" ? f : S;
      return /* @__PURE__ */ a.jsx(
        xe,
        {
          appliedPlacement: e,
          ariaDescribedby: o,
          biId: u,
          buttonProps: n,
          canSelectMultiple: r,
          condition: this._condition,
          isClearable: c,
          isDark: _,
          isDisabled: l,
          isFocused: t,
          isInvalid: this._condition === "error",
          isOpen: x,
          onClear: this._handleClear,
          placeholder: i != null && i.length ? i : z,
          renderToggleContent: b,
          selectedItems: h,
          size: p,
          type: m,
          variant: w,
          width: g
        }
      );
    }, this._menuRef = Q(), this.state = {
      isOpen: !1,
      isInvalid: !1,
      selectedItems: []
    };
  }
  get _condition() {
    const { condition: e } = this.props, { isInvalid: t } = this.state;
    return t ? "error" : e;
  }
  static getDerivedStateFromProps(e) {
    const { items: t, selectedValues: n } = e;
    if (!Array.isArray(n))
      throw new Error(`@fabric/select - "selectedValues" prop must be an instance of Array. Got ${typeof n}`);
    return {
      selectedItems: oe(t, N(t, n))
    };
  }
  _close() {
    const { open: e, onClose: t = d.noop } = this.props, n = t();
    if (typeof e != "boolean")
      return Promise.resolve(n).then(() => {
        this.setState({ isOpen: !1 });
      });
  }
  _change(e) {
    const { items: t, onChange: n = d.noop } = this.props, o = n(e, N(t, e));
    return Promise.resolve(o);
  }
  _deselect(e, t) {
    const { onDeselect: n = d.noop, selectedValues: o = [] } = this.props, u = o.filter((c) => c !== e.value), r = n(e.value, u, { item: e, parentItem: t });
    return Promise.resolve(r).then(() => this._change(u));
  }
  _open() {
    const { open: e, onOpen: t = d.noop } = this.props, n = t();
    if (typeof e != "boolean")
      return Promise.resolve(n).then(() => {
        this.setState({ isOpen: !0 });
      });
  }
  _select(e, t, n = { isQuickSelect: !1 }) {
    const { canSelectMultiple: o, onSelect: u = d.noop, selectedValues: r = [] } = this.props, { selectedItems: c } = this.state, { isQuickSelect: _ } = n;
    let l = r;
    const f = c;
    !ie(e) && !e.exclusive && !_ && o ? ae(f) ? l = [e.value] : l = [...r, e.value] : e.isActionOnly || (l = [e.value]);
    const i = u(e.value, l, { item: e, parentItem: t });
    return Promise.resolve(i).then(() => this._change(l));
  }
  render() {
    const {
      "aria-label": e,
      ariaLabel: t,
      biId: n,
      canSelectMultiple: o,
      id: u,
      inputRef: r,
      isDisabled: c,
      items: _,
      menuWidth: l,
      name: f,
      onAdd: i,
      onBlur: b,
      onSearch: p,
      open: m,
      placeholder: w,
      placement: g,
      renderOptionContent: S,
      renderToggleContent: h,
      required: x,
      searchPlaceholder: E,
      searchText: y,
      searchThreshold: v,
      showSearch: O,
      size: F,
      type: P,
      width: j
    } = this.props, { isOpen: W, selectedItems: I } = this.state, G = typeof m == "boolean" ? m : W, H = D({
      "fab-Select": !0,
      "fab-Select--fullWidth": C.ifFeature("encore", j == 100 && P !== "text", j == 100)
    }), k = t || e, X = I.length ? q(I, null, o) : w;
    return /* @__PURE__ */ a.jsxs("div", { className: H, "data-fabric-component": "Select", children: [
      /* @__PURE__ */ a.jsx(
        re,
        {
          ariaLabel: `${k || ""} ${X || ""}`,
          biId: n,
          canQuickSelect: !0,
          canSelectMultiple: o,
          condition: this._condition,
          isAttached: C.ifFeature("encore", !1, P !== "text"),
          isDisabled: c,
          isFullWidth: j == 100,
          isOpen: G,
          items: _,
          listRole: o ? "listbox" : "menu",
          onAdd: i,
          onBlur: b,
          onClose: () => this._close(),
          onDeselect: this._handleDeselect,
          onOpen: () => this._open(),
          onSearch: p,
          onSelect: this._handleSelect,
          placement: g,
          ref: this._menuRef,
          renderOptionContent: S,
          renderToggle: this._renderToggle,
          searchPlaceholder: E,
          searchText: y,
          searchThreshold: v,
          selectedItems: I,
          showSearch: O,
          size: F,
          width: l
        }
      ),
      /* @__PURE__ */ a.jsx(
        he,
        {
          canSelectMultiple: o,
          id: u,
          inputRef: r,
          isDisabled: c,
          name: f,
          onFocus: () => {
            const L = this._menuRef.current;
            L && L.focus();
          },
          onValidation: this._handleValidation,
          required: x,
          selectedValues: le(I)
        }
      )
    ] });
  }
};
A.defaultProps = {
  canSelectMultiple: !1,
  isClearable: !0,
  isDark: !1,
  isDisabled: !1,
  name: "",
  onChange: d.noop,
  onClose: d.noop,
  onDeselect: d.noop,
  onOpen: d.noop,
  onSelect: d.noop,
  placeholder: z,
  placement: {
    align: "start",
    side: "bottom"
  },
  required: !1,
  selectedValues: [],
  showSearch: "auto",
  size: U,
  variant: "form"
};
let R = A;
export {
  R as S
};
//# sourceMappingURL=select-DjbIs9Ff.mjs.map
